import { render, staticRenderFns } from "./incompatibleForMobile.vue?vue&type=template&id=b3ea1c8e&scoped=true&"
import script from "./incompatibleForMobile.vue?vue&type=script&lang=ts&"
export * from "./incompatibleForMobile.vue?vue&type=script&lang=ts&"
import style0 from "./incompatibleForMobile.vue?vue&type=style&index=0&id=b3ea1c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ea1c8e",
  null
  
)

export default component.exports